export default class Options {
  public callTimeMs = 10000
  public expediteTargets: Array<string> = []
  public garageTargets: Array<string> = []
  public enableGarageQueue = false
}
